import { db } from "services/firebase";

/**
 * Load an in-app help video catalog entry.
 * Docs live in `helpVideos/{workflowId}` with fields:
 *   title, description, storagePath | downloadUrl, roleTags[], status
 */
export async function getHelpVideo(workflowId) {
  if (!workflowId) return null;
  try {
    const snap = await db.collection("helpVideos").doc(workflowId).get();
    if (!snap.exists) return null;
    return { id: snap.id, ...snap.data() };
  } catch (err) {
    console.warn("[helpVideoService] load failed", workflowId, err);
    return null;
  }
}

export async function listHelpVideosForRole(roleTag) {
  try {
    const snap = await db
      .collection("helpVideos")
      .where("status", "==", "published")
      .limit(40)
      .get();
    return snap.docs
      .map((doc) => ({ id: doc.id, ...doc.data() }))
      .filter((row) => !roleTag || (row.roleTags || []).includes(roleTag));
  } catch (err) {
    console.warn("[helpVideoService] list failed", err);
    return [];
  }
}

/** Known workflow ids from tests-e2e/helpvideos/helpVideoInventory.md */
export const HELP_VIDEO_WORKFLOWS = {
  TCI_MANAGER_CANDIDATE_REVIEW: "tciManager-candidateReview",
  TCI_MANAGER_DASHBOARD: "tciManager-dashboard",
  TCI_MANAGER_MANAGE_TCIS: "tciManager-manageTcis",
  FDEC_SESSION_REPLAY: "fdeC-sessionReplay",
  FDEC_TEACHER_ANNOTATION: "fdeC-teacherAnnotation",
  FDEC_ANNOTATE: "fdec-annotateSession",
};
